module.exports = [
  {
    slug: "/why-dell",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/DAIF_Extra3_In.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/DAIF_Extra3_Loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/why-dell/1in",
        width: "28%",
        height: "4.5%",
        top: "74.6%",
        left: "68.4%",
      },
      {
        url: "/why-dell/2in",
        width: "28%",
        height: "4.5%",
        top: "79.2%",
        left: "68.4%",
      },
      {
        url: "/why-dell/3in",
        width: "28%",
        height: "4.5%",
        top: "83.9%",
        left: "68.4%",
      },
      {
        url: "/why-dell/4in",
        width: "28%",
        height: "4.5%",
        top: "88.5%",
        left: "68.4%",
      },
    ],
  },
  {
    slug: "/why-dellb",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Clean.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/DAIF_Extra3_Loop.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/DAIF_Extra3_Loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/why-dell/1in",
        width: "28%",
        height: "4.5%",
        top: "74.6%",
        left: "68.4%",
      },
      {
        url: "/why-dell/2in",
        width: "28%",
        height: "4.5%",
        top: "79.2%",
        left: "68.4%",
      },
      {
        url: "/why-dell/3in",
        width: "28%",
        height: "4.5%",
        top: "83.9%",
        left: "68.4%",
      },
      {
        url: "/why-dell/4in",
        width: "28%",
        height: "4.5%",
        top: "88.5%",
        left: "68.4%",
      },
    ],
  },

  {
    slug: "/why-dell/1in",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Clean.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/why-dell/1",
  },
  {
    slug: "/why-dell/2in",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Clean.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/why-dell/2",
  },
  {
    slug: "/why-dell/3in",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Clean.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/why-dell/3",
  },
  {
    slug: "/why-dell/4in",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Clean.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/why-dell/4",
  },

  {
    slug: "/why-dell/1",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_01.mp4'),
    videoTransitionInEnd: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_01_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/why-dellb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/why-dell/2",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_02.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_02_loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/why-dellb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/why-dell/3",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_03.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_03_loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/why-dellb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/why-dell/4",
    bgImage: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_01.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_01_loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_01-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/why-dellb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/why-dell/4/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/why-dell/4/1",
    bgImage: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_01-end.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_02.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_02_loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_02-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/why-dellb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/why-dell/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/why-dell/4/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/why-dell/4/2",
    bgImage: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_02-end.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_03.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_03_Loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_03-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/why-dellb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/why-dell/4/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/why-dell/4/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/why-dell/4/3",
    bgImage: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_03-end.jpg'),
    videoTransitionIn: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_04.mp4'),
    videoBgLoop: require('../assets/08_Why_Dell/08_DAIF_WHY_DELL_04_04_loop.mp4'),
    bgImage2: require('../assets/08_Why_Dell/DAIF_Extra3_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/why-dellb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/why-dell/4/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  
]